<template>
  <div style="width:100%;heigh:100%;">
    <div class="table_searchbar">
        <el-row :gutter="W?2:0">
            <el-col :span="span">
                <div class="" @keydown.enter="btnSearch()">
                <span class="title">IMEI：</span>
                <el-input class='target' style="width:180px" size="small" v-model="searchForm.imei" maxlength="16" placeholder="IMEI"></el-input>
                </div>
            </el-col>
            <el-col :span="span">
                <div class="" @keydown.enter="btnSearch()">
                      <span class="title">状态：</span>
                    <el-select style="max-width:180px" size="small" v-model="searchForm.status" maxlength="16" placeholder="请选择">
                      <el-option label="未激活" value="0"></el-option>
                      <el-option label="正常" value="1"></el-option>
                      <el-option label="设备离线" value="2"></el-option>
                      <el-option label="数据未上传" value="3"></el-option>
                      <el-option label="dtu离线" value="4"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="W?(14):10">
                <div style="text-align:right">
                    <el-button size='mini' type="primary" icon="el-icon-search" @click="btnSearch()">查询</el-button>
                    <el-button size='mini' icon="el-icon-refresh"  @click='clearSearch'>重置</el-button>
                </div>
            </el-col>
        </el-row>
    </div>

     <div class="table_common_operbar">
        <el-row>
            <el-button icon="el-icon-plus" type="primary" size="small" @click="addDialogShow()" v-if="permission.btn_dtu_add">新增</el-button>
        </el-row>
    </div>

    <!-- 新增窗口开始 -->
    <el-dialog title="新增DTU" :visible.sync="addDialogVisible" width="500px" center :close-on-click-modal="false">
        <el-form :model="addForm" :rules="rules" ref="addForm" class="addForm">
            <el-row :gutter="20">
                <div class="">
                    <el-form-item label="IMEI：" label-width="100px" class="value" prop="imei">
                        <el-input style="width:300px" size="small" ref="focusinput" v-model="addForm.imei" maxlength="32"  ></el-input>
                    </el-form-item>
                </div>
            </el-row>
            <el-row :gutter="20">
                <div class="">
                    <el-form-item label="地址：" label-width="100px" class="value" prop="address">
                        <el-input style="width:300px" size="small" v-model="addForm.address" maxlength="32" placeholder="请输入准确的地址信息，包含省市区"></el-input>
                         <!-- <el-autocomplete size="small" v-model="addForm.address" :fetch-suggestions="queryAddrAsync" placeholder="DTU地址" class="form__input" /> -->
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addDtu()">确 定</el-button>
            <el-button @click="addDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>

    <!-- 编辑窗口开始 -->
    <el-dialog title="编辑DTU" :visible.sync="editDialogVisible" width="500px" center :close-on-click-modal="false">
        <el-form :model="editForm" :rules="rules" ref="editForm" class="addForm">
            <el-row :gutter="20">
                <div class="">
                    <el-form-item label="IMEI：" label-width="100px" class="value" prop="imei">
                        <el-input style="width:300px" size="small" v-model="editForm.imei" maxlength="32"></el-input>
                    </el-form-item>
                </div>
            </el-row>
            <el-row :gutter="20">
                <div class="">
                    <el-form-item label="地址：" label-width="100px" class="value" prop="address">
                        <el-input style="width:300px" size="small" v-model="editForm.address" maxlength="60" placeholder="请输入准确的地址信息，包含省市区"></el-input>
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="editDtu()">确 定</el-button>
            <el-button @click="editDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>

     <!-- 查看窗口开始 -->
    <el-dialog class="view_dialog" title="查看DTU"  width="800px" :visible.sync="viewDialogVisible"  center :close-on-click-modal="false">
        <div>
          <h4>基本信息</h4><br>
          <el-row>
            <el-col :span="14" :push="2"><b>IMEI：</b>{{currentRow.imei}}</el-col>
            <el-col :span="8"><b>经度</b>：{{currentRow.longitude}}</el-col>
          </el-row>
          <el-row>
            <el-col :span="14" :push="2"><b>地址：</b>{{currentRow.address}}</el-col>
            <el-col :span="8"><b>纬度：</b>{{currentRow.latitude}}</el-col>
          </el-row>
          <br>
          <el-row>
            <el-col :span="3"><h4 style="position: relative;top: 5px;">已绑定设备</h4></el-col>
            <el-col :span="6" v-if="permission.btn_dtu_bind">
              <el-select
                v-model="equipmentQuery"
                filterable
                remote
                reserve-keyword
                placeholder="请输入设备编号"
                :remote-method="deviceUn"
                :loading="remoteLoading"
              >
                <el-option
                  v-for="item in restaurants"
                  :key="item.equId"
                  :label="item.value"
                  :value="item.equId"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1" v-if="permission.btn_dtu_bind"> <el-button size="small" type="primary" plain @click="bindEquipment">绑定设备</el-button ></el-col>
          </el-row>
          <el-table :data="equipmentData" style="width: 100%;" max-height="300px">
            <el-table-column prop="deviceCode" label="设备编号"  ></el-table-column>
            <el-table-column prop="gmtCreate" :formatter='parseDate' label="创建时间"  ></el-table-column>
            <el-table-column label="操作" fixed="right" v-if="permission.btn_dtu_unbind">
                <template slot-scope="scope">
                    <el-button @click="unbind(scope.row)" type="text" size="small" >解绑</el-button>
                </template>
            </el-table-column>
          </el-table>

        </div>
        <span slot="footer" class="dialog-footer" style="margin-top:50px; margin-bottom:30px;">
            <el-button type="primary" @click="viewDialogVisible = false">确 定</el-button>
        </span>
    </el-dialog>

    <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="imei" label="IMEI"  ></el-table-column>
        <!-- <el-table-column prop="address" label="地址"  ></el-table-column> -->
        <el-table-column prop="address" label="状态" :formatter="row=>{return dtuStatus.get(row.status)}" ></el-table-column>
        <el-table-column prop="gmtCreate" :formatter='parseDate' label="创建时间"  ></el-table-column>
        <el-table-column label="操作" fixed="right" width="200px">
            <template slot-scope="scope">
                <el-button @click="viewDtu(scope.row)" type="text" size="small" v-if="permission.btn_dtu_get">查看</el-button>
                <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_dtu_update">编辑</el-button>
                <el-button @click="deleteDtu(scope.row)" type="text" size="small" v-if="permission.btn_dtu_delete">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div class="page" v-if="tableData.length > 0">
      <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
      <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
          <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
          </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { resolve, reject } from 'q';

export default {
  name:"dtumgt",
  data:()=>{
    return {
      W:false,
      fristLoad:false,
      addDialogVisible:false,
      editDialogVisible:false,
      viewDialogVisible:false,
      btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: '',//临时搜索数据
      searchForm:{
          imei:'',
          status:'',
          itemCode: '',
      },
      dtuStatus: new Map([
        [0,'未激活'],
        [1,'正常'],
        [2,'设备离线'],
        [3,'数据未上传'],
        [3,'dtu离线'],
      ]),
      addForm:{
        imei:'',
        address:''
      },
      editForm:{
        id:'',
        imei:'',
        address:''
      },
      rules:{
          imei:[
              { required: true, message: '请输入IMEI', trigger: 'blur' }
          ],
      },
      tableData:[],
      currentRow:{},
      tableTotalPage:100,
      tableCurrentPage:1,
      permission:JSON.parse(localStorage.getItem("permission")),

      /*** 绑定设备相关 **/
      remoteLoading: false,
      restaurants:[], //设备下拉列表
      equipmentData:[],
      equipmentQuery:''
    }
  },
  mounted:function(){
      this.initTable();
      let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
      window.onresize=()=>{
          let w  = document.documentElement.clientWidth || document.body.clientWidth;
          w>=1900?this.W = true:this.W = false
      }
  },
  computed:{
      span(){
          return this.W?5:7
      }
  },
  methods: {
    search:function(){
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp ={
            status:'',
            imei:'',
          };
          break;
        case 2:
          temp = this.searchFormTemp
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
        this.$RequestUtil.get({
            url: '/api/dtu/listDtu',
            type:'sync',
            params: {
                pageNum:this.tableCurrentPage,
                pageSize:10,
                imei:temp.imei,
                status:temp.status,
            },
            success: (res) => {
                if(res.msg == this.$Global.RESPONSE.SUCCESS){
                    this.tableData = res.data;
                    this.tableTotalPage = res.totalPages;
                    if(res.totalPages == 0&&this.fristLoad){
                        this.$message.warning('查询不到符合条件的数据');
                    }
                    this.fristLoad = true
                }else{
                    this.$message.error(res.message||res.msg)
                }
                
            }
        });
    },
    pageChange:function(targetPage){
        this.tableCurrentPage = targetPage;
        this.btnPressType = 3;
        this.search();
    },
    initTable:function(){
        this.search();
    },
    addDialogShow(){
        this.addDialogVisible = true;
        this.addForm = {
            imei:'',
            status:'',
        }
        setTimeout(()=>{
            this.$refs.focusinput.focus()
        },0)
    },
    btnSearch:function(){
        this.tableCurrentPage = 1;
        this.btnPressType = 1
        this.search();
    },
    clearSearch(){
      this.btnPressType = 2;
      this.searchForm.imei = '';
      this.searchForm.status = '';
    },
    addDtu:function(){
      this.$refs['addForm'].validate((valid) => {
          if (valid) {
              this.$RequestUtil.post({
                  url: '/api/dtu/addDtu',
                  type:'sync',
                  params: {
                    imei:this.addForm.imei,
                    address:this.addForm.address
                  },
                  success: (res) => {
                      if(res.code == 0){
                          this.$message({
                              type:'success',
                              message:'添加成功'
                          })
                          this.initTable();
                          this.addDialogVisible = false;
                      }else{
                          this.$message({
                              type: 'error',
                              message: res.message||res.msg
                          });
                      }
                  }
              });
          }else{
              this.$message({
                  type: 'error',
                  message: '请补充必填项!'
              });
          }
      });
    },
    showEditDialog:function(rowData){
      this.getDtuDetail(rowData).then(res=>{
        this.editForm.id = rowData.id;
        this.editForm.imei = rowData.imei;
        this.editForm.address = res.address;
        this.editDialogVisible = true;
      })
    },
    editDtu:function(){
      this.$refs['editForm'].validate((valid) => {
          if (valid) {
              this.$RequestUtil.post({
                  url: '/api/dtu/updateDtu',
                  type:'sync',
                  params: {
                    id:this.editForm.id,
                    imei:this.editForm.imei,
                    address:this.editForm.address
                  },
                  success: (res) => {
                      if(res.code == 0){
                          this.$message({
                              type:'success',
                              message:'编辑成功'
                          })
                          this.initTable();
                          this.editDialogVisible = false;
                      }else{
                          this.$message({
                              type: 'error',
                              message: res.message||res.msg
                          });
                      }
                  }
              });
          }else{
              this.$message({
                  type: 'error',
                  message: '请补充必填项!'
              });
          }
      });
    },
    deleteDtu:function(rowData) {
      this.$confirm('此操作将删除该DTU, 是否继续?', '提示', {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.$RequestUtil.get({
              url: '/api/dtu/deleteDtu',
              type:'sync',
              params: {
                  id:rowData.id
              },
              success: (res) => {
                  if(res.code != -1){
                      this.$message({
                          type: 'success',
                          message: '删除成功!'
                      });
                      this.initTable();
                  }else {
                    this.$message({
                      type: 'error',
                      message: res.message
                    });
                  }
              }
          });
      });
    },
    getDtuDetail(rowData){
      return new Promise((resolve,reject)=>{
        this.$RequestUtil.get({
          url: '/api/dtu/getDtuDetail',
          type:'sync',
          params: {
              id:rowData.id
          },
          success: (res) => {
              if(res.code != -1){
                  resolve(res.data);
              }else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
                reject(res)
              }
          }
        });
      })
    },
    viewDtu(rowData){
      this.currentRow = rowData;
      this.getDtuDetail(rowData).then(data=>{
        this.equipmentData = data.bindingList;
        this.equipmentQuery='';
        this.currentRow.address = data.address;
        this.viewDialogVisible = true;
      });
      
    },
    parseDate:function(rowData){
        if(rowData.gmtCreate != null){
            let dateString = commonUtils.timestampToDate(rowData.gmtCreate,false);
            return dateString;
        }
    },
    queryAddrAsync(queryString, cb) {
      axios.get("	https://restapi.amap.com/v3/place/text", {
        params: {
          key: "8325164e247e15eea68b59e89200988b",
          keywords: queryString,
          city: '',
          offset: 20,
          page: 1,
          extensions: "all"
        }
      }).then((response) => {
        console.log(response.data.pois);
        cb(response.data.pois.map(e => {
          return {value: e.name}
        }))
      });
    },

    /**绑定设备相关 */

    deviceUn(query) {
      this.restaurants = [];
      this.remoteLoading = true;
      this.$RequestUtil.get({
        url: "/api/select/listUnboundDevices",
        params: { deviceCode: query },
        success: data => {
          if (data.code == 0) {
            this.restaurants = data.data.map(e => {
              return {
                value: e.deviceCode,
                equId: e.id
              };
            });
          } else {
            this.$message({
                type: 'error',
                message: data.message||data.msg
            });
          }
          this.remoteLoading = false;
        }
      });
    },

    getEquipmentList(){
      this.$RequestUtil.get({
        url: '/api/select/listUnboundDevices',
        type:'sync',
        params: {
          deviceCode:this.addForm.imei,
        },
        success: (res) => {
            if(res.code == 0){
                this.$message({
                    type:'success',
                    message:'绑定成功'
                })
                this.initTable();
                this.addDialogVisible = false;
            }else{
                this.$message({
                    type: 'error',
                    message: res.message||res.msg
                });
            }
        }
      });
    },

    bindEquipment(){
      if(!this.equipmentQuery){
        this.$message.warning("请选择要绑定的设备");
        return
      }
      this.$RequestUtil.post({
        url: '/api/dtu/bind',
        type:'sync',
        params: {
          dtuId:this.currentRow.id,
          deviceId:this.equipmentQuery
        },
        success: (res) => {
            if(res.code == 0){
                this.$message({
                    type:'success',
                    message:'绑定成功'
                })
                this.getDtuDetail(this.currentRow).then(data=>{
                  this.equipmentData = data.bindingList;
                  this.equipmentQuery = '';
                  this.restaurants = [];
                });
            }else{
                this.$message({
                    type: 'error',
                    message: res.message||res.msg
                });
            }
        }
    });
    },
    unbind(rowData){
      this.$confirm('此操作将解绑该设备, 是否继续?', '提示', {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.$RequestUtil.get({
              url: '/api/dtu/unbind',
              type:'sync',
              params: {
                  id:rowData.id
              },
              success: (res) => {
                  if(res.code != -1){
                      this.$message({
                          type: 'success',
                          message: '解绑成功!'
                      });
                      this.getDtuDetail(this.currentRow).then(data=>{
                        this.equipmentData = data.bindingList;
                        this.equipmentQuery = '';
                        this.restaurants = [];
                      });
                  }else {
                    this.$message({
                      type: 'error',
                      message: res.message
                    });
                  }
              }
          });
      });
    }
  }
}
</script>
<style scoped>
  .table_searchbar{
      width:100%;
      margin-top: 10px;
      margin-bottom: 20px;
  }
  .table_searchbar .title11{
    color:  #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .addForm .value{
      display: inline-block;
      width: 280px;
      text-align: center
  }
  .addForm .title{
      width: 70px;
      text-align: right;
      display:inline-block
  }
  .page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/views/masterdata/DtuMgt.vue